module.exports = "../study/imgs/maps/Kanagawa/S8/WaterEnvironment/Chlmax/Kanagawa_Chlmax_HadGEM2_RCP85_End.png";